import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-cost-reactive-form',
    templateUrl: './cost-reactive-form.component.html',
    styleUrls: ['./cost-reactive-form.component.scss']
})
export class CostReactiveFormComponent {

    /**
     * form: FormGroup
     */
    @Input()
    public form: FormGroup

    /**
     * readonly
     */
    @Input()
    public readonly: boolean;

    /**
     * required
     */
    @Input()
    public required: boolean = true;

    /**
     * showMinimumTerm
     */
    @Input()
    public showMinimumTerm: boolean = true;
}